/**
 * Created by pajicv on 9/28/18.
 */
import React from 'react';
import { Typography, Button, withStyles } from '@material-ui/core';
//import AddIcon from '@material-ui/icons/Add';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        marginTop: 20
    },
    column1: {
        width: 150,
        textAlign: 'left'
    },
    column2: {
        width: 200,
        textAlign: 'right'
    },
    column3: {
        width: 200,
        textAlign: 'left'
    },
});

class MemberFooter extends React.Component {

    render() {
        const {classes, onInviteClick} = this.props;
        return (
            <div className={classes.root}>
                <Typography
                    variant="title"
                    className={classes.column1}
                >
                    {' '}
                </Typography>
                <div className={classes.column2}>
                    {/*
                    <Button onClick={onAddMemberClick} style={{marginRight: 10}} variant="fab" color="primary">
                        <AddIcon />
                    </Button>
                    */}
                </div>
                <Button onClick={onInviteClick} variant="contained" color="primary" className={classes.column3}>
                    EINLADEN
                </Button>
            </div>
        );
    }

}

export default withStyles(styles)(MemberFooter);



// WEBPACK FOOTER //
// ./src/components/common/MemberFooter.js